import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { OrdersEdge } from '@shared/generated'
import { formatPrice } from '@shared/uttils'
import { ORDER_STATUS_IN_PROGRESS } from '@shared/uttils/order'

import styles from './styles.module.scss'

interface Props {
  data: NonNullable<NonNullable<OrdersEdge['edges']>[number]>;
}

export default function OrderSummary ({ data }: Props) {
  const { t: to } = useTranslation('order')
  const { t: tc } = useTranslation('common')
  const order = data

  const totalCashback = order?.totalCashback ?? 0

  return (
    <div className={styles.summary}>
      <h5>{to('order.total')}:</h5>

      {data?.meta?.length ? (
        <SummaryRow
          label={to('order.total-position')}
          value={`${data?.meta?.length} ${tc('weight.pc')}`}
        />
      ) : null}
      {data?.deliveryCost ? (
        <SummaryRow
          label={to('order.delivery-price')}
          value={formatPrice(data?.deliveryCost as number)}
        />
      ) : null}
      {data?.totalDiscount ? (
        <SummaryRow
          className={styles.summary__bonus}
          label={to('order.total-sum')}
          value={formatPrice(
            ((data.customerFinalCost as number) +
              data?.totalDiscount) as number,
          )}
        />
      ) : null}
      <SummaryRow
        label={to('order.total')}
        value={formatPrice(data?.customerFinalCost || 0)}
        isTotal
      />
      {data?.totalDiscount ? (
        <SummaryRow
          label={to('order.discount')}
          value={formatPrice(data?.totalDiscount)}
        />
      ) : null}
      {data?.totalCashback ? (
        <SummaryRow
          isBonus
          label={to('order.total-bonus')}
          value={formatPrice(data?.totalCashback)}
        />
      ) : null}
      {totalCashback > 0 && (
        <SummaryRow
          isBonus
          label={
            ORDER_STATUS_IN_PROGRESS.includes(order.status)
              ? to('add-bonus_history')
              : to('add-bonus')
          }
          value={`${totalCashback} ${to('order.bonus-short')}`}
        />
      )}
    </div>
  )
}

interface SummaryRowProps {
  label: string;
  value: string;
  isTotal?: boolean;
  isBonus?: boolean;
  className?: string;
}

function SummaryRow ({
  label,
  value,
  isTotal = false,
  isBonus = false,
  className = '',
}: SummaryRowProps) {
  return (
    <p className={className}>
      {label}:
      <span data-total={isTotal || undefined}>
        {isBonus && <ReactSVG src="/icons/bonus.svg" />}
        {value}
      </span>
    </p>
  )
}
